import {
  Table,
  TableBody,
  Grid,
  TextField,
  TableCell,
  TableRow
} from '@material-ui/core';
import React, { Component } from 'react';
import PageHeader from '../common/PageHeader';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  GenerateAbsoluteURL,
  getCurrentPayCycleStartDateByDate,
  removeDuplicates,
  IsSensitiveDataAccess,
  EnhancedTableHead,
  orderBy,
  numberWithCommas,
  with2DecimalsPoints,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import _ from 'lodash';
import Reports from './Reports';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { DateFormat } from '../../constants/appConstants';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import './report.less';
import { getFormattedValues } from '../../utils/formatData';
import { getMultilevelGroupedData } from '../../utils/generic';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import { collapsableAllocationPercent, collapsableReimbursement, extendibleMarkerReimbursArray } from '../../constants/MockData';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

let defaultPayPeriod = [];
export default class YearEndBonusMarketReimbursementReport extends Component {
  constructor(props) {
    super(props);
    this.baseState = {
      showMain: false,
      departmentMasterData: [],
      employeeMasterData: [],
      marketMasterData: [],
      expenseGroupMasterData: [],
      divisionMasterData: [],
      expenseNameMasterData: [],
      detailView: false,
      selectedEmployeeId: undefined,
      openForm: false,
      selectedData: [],
      marketReimburseData: [],
      rows: [],
      payPeriodRadio: '',
      showReport: false,
      market: [{ marketName: 'All' }],
      department: [{ departmentName: 'All' }],
      property: [{ propertyName: 'All' }],
      employee: [{ employeeName: 'All' }],
      expenseGroup: [{ expenseGroup: 'All' }],
      expenseName: [{ expenseName: 'All' }],
      division: [{ division: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      openSlidingPanel: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Department',
              id: 'departmentName',
              value: 'departmentName',
              ssrsReport: 'DepartmentName',
              numeric: false,
              disablePadding: false,
              label: 'Department',
              type: 'Text',
              order: 2
            },
            {
              key: 'Division',
              id: 'division',
              value: 'division',
              ssrsReport: 'Division',
              numeric: false,
              disablePadding: false,
              label: 'Division',
              type: 'Text',
              order: 3
            },
            {
              key: 'Employee',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'Employee',
              numeric: false,
              disablePadding: false,
              label: 'Employee',
              type: 'Text',
              order: 4
            },
            {
              key: 'Expense Group',
              value: 'expenseGroup',
              id: 'expenseGroup',
              ssrsReport: 'ExpenseGroup',
              numeric: false,
              disablePadding: false,
              label: 'Expense Group',
              type: 'Text',
              order: 5
            },
            {
              key: 'Expense Name',
              value: 'expenseName',
              id: 'expenseName',
              ssrsReport: 'ExpenseName',
              numeric: false,
              disablePadding: false,
              label: 'Expense Name',
              type: 'Text',
              order: 6
            }],
          selected: [{
            key: 'Market',
            value: 'marketName',
            id: 'marketName',
            ssrsReport: 'MarketName',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text',
            order: 1
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: true,
        summaryRows: true,
        suppressDetails: false,
        showZeroNGraph: true,
        startDate: moment().startOf('month').format(DateFormat),
        RadioSelect: 'MTD'
      },
      summaryCols: ['reimbursementCost'],
      printPage: false,
      payPeriod: [],
      expand: true,
      agree: false,
      confirmationMessage: '',
      handleCollapse: false,
      order: 'asc',
      orderBy: 'nam',
      supervisorEmployeeMasterData: [],
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };

    this.state = this.baseState;
  }

  componentDidMount() {
    localStorage.setItem('selectedstartDate', moment().startOf('month').format('MM/DD/YYYY'));
    this.GetMasterData();
  }

  // Function is used to get all master data for filters
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Report.GetExpenseGroup,
        key: 'expenseGroupMasterData'
      },
      {
        url: API_URL.Report.GetExpenseName,
        key: 'expenseNameMasterData'
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'divisionMasterData'
      }
    ])
      .then(
        ({
          employeeMasterData,
          departmentMasterData,
          marketMasterData,
          expenseGroupMasterData,
          expenseNameMasterData,
          divisionMasterData
        }) => {
          this._asyncRequest = null;
          if (marketMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            employeeMasterData: employeeMasterData.data,
            departmentMasterData: departmentMasterData.data,
            marketMasterData: marketMasterData.data,
            expenseGroupMasterData: expenseGroupMasterData.data,
            expenseNameMasterData: expenseNameMasterData.data,
            divisionMasterData: divisionMasterData.data,
            supervisorEmployeeMasterData: employeeMasterData.data || []
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
              this.handleSubmit();
            }            
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Function is used to get market Rimbursement Data for Year End pay cycle
  GetMarketReimburseData() {
    const {
      market,
      property,
      department,
      employee,
      payPeriodStartDate,
      expenseGroup,
      expenseName,
      division,
      SupervisorEmployee
    } = this.state;

    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const expenseGroupId = _.cloneDeep(expenseGroup.map((x) => x.expenseGroupId));
    const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
    const divisionId = _.cloneDeep(division.map(x => x.divisionId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    const params = {
      year: moment(moment(payPeriodStartDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
      marketId: marketId.join('|'),
      propertyId: propertyId.join('|'),
      departmentId: departmentId.join('|'),
      employeeId: employeeId.join('|'),
      expenseGroupId: expenseGroupId.join('|'),
      expenseNameId: expenseNameId.join('|'),
      divisionId: divisionId.join('|'),
      supervisorId: supervisorId.join('|')
    };

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetMarketReimburseData,
        params,
        key: 'marketReimburseData'
      }
    ]).then(({ marketReimburseData }) => {
      this._asyncRequest = null;
      if (marketReimburseData.success !== true) {
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      }
      const marketReimburseDataValue = marketReimburseData.data || [];
      const payPeriod = marketReimburseDataValue.length > 0
        ? _.chain(marketReimburseDataValue[0].reimbursmentDetails).groupBy('payPeriod')
          .map(function (_des, desi) {
            return {
              payPeriod: desi,
              isCollapsed: false
            };
          })
          .value()
        : [];
      defaultPayPeriod = payPeriod;
      const rows = this.getTableRow(marketReimburseDataValue);
      this.setState({
        marketReimburseData: marketReimburseDataValue,
        rows,
        payPeriod,
        showReport: true,
        expand: true,
        isSubmitButtonClicked: true,
      });
    });
  }

  // Function is used to navigate all reports list
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Function is used to handle Advanced filter setting changes
  onAddvanceFilterChange = (advanceFilterConfig) => {
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false,
      orderBy: advanceFilterConfig?.groupBy?.selected.length > 0
        ? advanceFilterConfig?.groupBy?.selected[0]?.value
        : (advanceFilterConfig?.groupBy?.masterData[0]?.value !== undefined ? advanceFilterConfig?.groupBy?.masterData[0]?.value : this.state.orderBy),
      order: advanceFilterConfig?.groupBy?.selected.length > 0
        ? 'asc'
        : (advanceFilterConfig?.groupBy?.masterData[0]?.value !== undefined ? 'asc' : this.state.order)
    }, () => this.GetMarketReimburseData());
  }

  // Function is used to handle filter value changes
  handleChange = (e, value, name, optionLabel) => {
    if (name !== null) {
      if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
          this.setState({ [name]: value });
        } else if ((value || []).find(x => x[optionLabel] === 'All')) {
          this.setState({ [name]: [{ [optionLabel]: 'All' }] });
        } else {
          this.setState({ [name]: value });
        }
      } else {
        value = (value || []).filter(x => x[optionLabel] !== 'All');
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
        }
        this.setState({ [name]: value });
      }
    } else {
      this.setState({ [name]: e.target.value });
    }
  };

  // Function is used to close Advanced filter popup
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Function is used to handle date/year selection change on calendar
  handleDateChange = (date, name) => {
    const { advanceFilterConfig } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');
    let formattedDate = moment(date).format(DateFormat);
    if (name === 'payPeriodStartDate') {
      formattedDate = getCurrentPayCycleStartDateByDate(date).format(DateFormat);
      advanceFilterConfig.startDate = formattedDate;
      localStorage.setItem('selectedstartDate', formattedDate);
      this.setState({
        [name]: formattedDate
      });
    }
  };

  // Function is used to reset the filters
  resetPage = () => {
    const { advanceFilterConfig } = this.state;
    advanceFilterConfig.summaryRows = true;
    advanceFilterConfig.suppressZero = true;
    advanceFilterConfig.suppressDetails = false;
    advanceFilterConfig.suppressDetails = false;
    advanceFilterConfig.startDate = moment().startOf('month').format(DateFormat);
    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Department',
          id: 'departmentName',
          value: 'departmentName',
          ssrsReport: 'DepartmentName',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 2
        },
        {
          key: 'Division',
          id: 'division',
          value: 'division',
          ssrsReport: 'Division',
          numeric: false,
          disablePadding: false,
          label: 'Division',
          type: 'Text',
          order: 3
        },
        {
          key: 'Employee',
          value: 'employeeName',
          id: 'employeeName',
          ssrsReport: 'Employee',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 4
        },
        {
          key: 'Expense Group',
          value: 'expenseGroup',
          id: 'expenseGroup',
          ssrsReport: 'ExpenseGroup',
          numeric: false,
          disablePadding: false,
          label: 'Expense Group',
          type: 'Text',
          order: 5
        },
        {
          key: 'Expense Name',
          value: 'expenseName',
          id: 'expenseName',
          ssrsReport: 'ExpenseName',
          numeric: false,
          disablePadding: false,
          label: 'Expense Name',
          type: 'Text',
          order: 6
        }],
      selected: [{
        key: 'Market',
        value: 'marketName',
        id: 'marketName',
        ssrsReport: 'MarketName',
        numeric: false,
        disablePadding: false,
        label: 'Market',
        type: 'Text',
        order: 1
      }]
    };
    localStorage.setItem('selectedstartDate', advanceFilterConfig.startDate);
    this.setState({
      ...this.baseState,
      advanceFilterConfig,
      payPeriodStartDate: advanceFilterConfig.startDate,
      isSubmitButtonClicked: false,
      showReport: this.state.isAutoRunEnabled ? true : false
    }, this.componentDidMount());
  };

  // Function is used to submit the details to fetch the required data
  handleSubmit = () => {
    localStorage.setItem('DateRadioSelect', 'CDR');
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    this.GetMarketReimburseData();
  };

  // Function is used to open Advanced Filter popup
  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  // Function is used to print the report
  handlePrintClick = () => {
    this.handleExport('application/pdf', 'Pdf', true);
  };

  getSupprssDetailsColumnCount = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      const columns = [];
      const allColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
      const selectedColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
      const diffColumns = allColumns.length - selectedColumns.length;
      for (let c = 0; c < diffColumns; c++) {
        columns.push(c + 1);
      }
      return columns;
    } else {
      return [];
    }
  }

  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
    } else {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
    }
  }

  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  renderTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const payPeriod = defaultPayPeriod;
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
    const sequence = this.getColumnSequence();
    let column1 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[0]?.value) || {}).value ?? '' : '';
    let column2 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[1]?.value) || {}).value ?? '' : '';
    let column3 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[2]?.value) || {}).value ?? '' : '';
    let column4 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[3]?.value) || {}).value ?? '' : '';
    let column5 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[4]?.value) || {}).value ?? '' : '';
    let column6 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[5]?.value) || {}).value ?? '' : '';

    groupedData.forEach((d, i) => {
      if (d.data !== undefined) {
        rowCount = 0;
        currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
        currentGroupedRow.push({ key: d.key, value: d[d.key] });
        if (this.state.advanceFilterConfig.summaryRows === false) {
          this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
        }
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(currentGroupedRow));
      const sequence = this.getColumnSequence();

      if (d.reimbursmentDetails) {
        const evenOddClass =
          tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        const topBorderClass =
          column1 !== (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
        const key = d.marketName + '_' + d.departmentName + d.division + '_' + d.employeeName + '_' + rowCount + '_' + i + d.isGroup;
        if (d.reimbursmentDetails.length > 0 &&
          (d.reimbursmentDetails[0].isSummary === undefined ||
            (d.reimbursmentDetails.length > 0 && d.reimbursmentDetails[0].isSummary === true &&
              this.state.advanceFilterConfig.summaryRows === true))) {
          if ((suppressDetails && d.isGroup) || (!suppressDetails)) {
            tableCell.push(
              <TableRow
                className={(this.state.advanceFilterConfig.summaryRows === true ? topBorderClass : '') + (d.isGroup === true ? ' parent-row' : '')}
              >
                {((d[sequence[0]?.value] || (!suppressDetails)) || (suppressDetails && sequence[0]?.value !== '')) && (
                  <TableCell
                    className={'st sticky ' + evenOddClass + (column1 !== d[sequence[0]?.value] &&
                      ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[0]?.value])
                      ? topBorderClass
                      : '')}
                  >
                    {getFormattedValues(column1 !== d[sequence[0]?.value] && d[sequence[0]?.value], 'Text')}{' '}
                  </TableCell>
                )
                }
                {((d[sequence[1]?.value] || (!suppressDetails)) || (suppressDetails && sequence[1]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-1 ' +
                      evenOddClass +
                      (column2 !== d[sequence[1]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[1]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[1]?.value)}</span>
                      : getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[2]?.value] || (!suppressDetails)) || (suppressDetails && sequence[2]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-2 ' +
                      evenOddClass +
                      (column3 !== d[sequence[2]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[2]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[2]?.value)}</span>
                      : getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[3]?.value] || (!suppressDetails)) || (suppressDetails && sequence[3]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-3 ' +
                      evenOddClass +
                      (column4 !== d[sequence[3]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[3]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[3]?.value)}</span>
                      : getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[4]?.value] || (!suppressDetails)) || (suppressDetails && sequence[4]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-4 ' +
                      evenOddClass +
                      (column5 !== d[sequence[4]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[4]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[4]?.value)}</span>
                      : getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text')}
                  </TableCell>
                )
                }
                {((d[sequence[5]?.value] || (!suppressDetails)) || (suppressDetails && sequence[5]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-5 ' +
                      evenOddClass +
                      (column6 !== d[sequence[5]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[5]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[5]?.value)}</span>
                      : getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text')}
                  </TableCell>
                )
                }
                {payPeriod.map((date, ind) => (
                  this.renderReimbursementColumn(d.reimbursmentDetails, date, key + ind, evenOddClass, d)
                ))}
              </TableRow>
            );
          }
        }
        rowCount++;
        column1 = (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '';
        column2 = (keyvalue.find(x => x.key === sequence[1]?.value) || {}).value ?? '';
        column3 = (keyvalue.find(x => x.key === sequence[2]?.value) || {}).value ?? '';
        column4 = (keyvalue.find(x => x.key === sequence[3]?.value) || {}).value ?? '';
        column5 = (keyvalue.find(x => x.key === sequence[4]?.value) || {}).value ?? '';
        column6 = (keyvalue.find(x => x.key === sequence[5]?.value) || {}).value ?? '';
      }
      if (d.data !== undefined && this.state.advanceFilterConfig.summaryRows === true && d.isGroup === true) {
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      }
    });
    return tableCell;
  }

  getGroupedArray(d, key) {
    return '';
  }

  renderReimbursementColumn = (reimbursementDetails, payPeriod, index, evenOddClass, d) => {
    const reimbursementDetail = reimbursementDetails.filter(x => moment(x.payPeriod).format(DateFormat) === moment(payPeriod.payPeriod).format(DateFormat));
    const isSensitiveData = IsSensitiveDataAccess();

    const tableCell = [];
    tableCell.push(<>
      {(payPeriod.isCollapsed === false || !isSensitiveData) && (
        <>
          <TableCell className={(evenOddClass + 'rpt-topBorder')} key={index + 'allocationRate'}>
            {
              reimbursementDetail.map((reimburse, ind) =>
                <div key={index + 'allocationRate' + ind} className={((reimbursementDetail.length) > 1 &&
                  ind !== (reimbursementDetail.length - 1))
                  ? 'multi-pay-period'
                  : ''}>
                  {d.isGroup === true && reimburse.allocationRate === undefined
                    ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse.allocationRate)}</span>
                    : (reimburse.allocationRate === null || isNaN(parseFloat(reimburse.allocationRate)))
                      ? <span className="number-text">-</span>
                      : (parseFloat(reimburse.allocationRate) >= 0
                        ? <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>{numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.allocationRate), 'Percent'))}%</span>
                        : <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.allocationRate)), 'Percent'))})%</span>
                      )
                  }
                </div>
              )
            }
          </TableCell>
        </>)
      }
      {
        (payPeriod.isCollapsed === false && isSensitiveData) && (
          <TableCell className={(evenOddClass + 'rpt-topBorder')} key={index + 'expenseAmount'}>
            {
              reimbursementDetail.map((reimburse, ind) =>
                <div key={index + 'expenseAmount' + ind} className={((reimbursementDetail.length) > 1 &&
                  ind !== (reimbursementDetail.length - 1))
                  ? 'multi-pay-period'
                  : ''}>
                  {(reimburse.expenseAmount === null || isNaN(parseFloat(reimburse.expenseAmount)))
                    ? <span className="number-text">-</span>
                    : (parseFloat(reimburse.expenseAmount) >= 0
                      ? <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>${numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.expenseAmount), 'Percent'))}</span>
                      : <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>$({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.expenseAmount)), 'Percent'))})</span>)
                  }
                </div>
              )
            }
          </TableCell>
        )
      }
      {isSensitiveData
        ? <TableCell className={(evenOddClass + 'right-border  rpt-topBorder')} key={index + 'reimbursementCost'}>
          {
            reimbursementDetail.map((reimburse, ind) =>
              <div key={index + 'reimbursementCost' + ind} className={((reimbursementDetail.length) > 1 &&
                ind !== (reimbursementDetail.length - 1))
                ? 'multi-pay-period'
                : ''}>
                {(reimburse.reimbursementCost === null || isNaN(parseFloat(reimburse.reimbursementCost)))
                  ? <span className="number-text">-</span>
                  : (parseFloat(reimburse.reimbursementCost) >= 0
                    ? <span className={this.state.expand === true ? 'report-percent-text-rate-expanded' : 'report-percent-text-cost'}>${numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.reimbursementCost), 'Percent'))}</span>
                    : <span className={this.state.expand === true ? 'report-percent-text-rate-expanded' : 'report-percent-text-cost'}>$({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.reimbursementCost)), 'Percent'))})</span>
                  )
                }
              </div>
            )
          }
        </TableCell>
        : ''}
    </>);
    return tableCell;
  }

  renderTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter(x => {
        return _.chain(x.reimbursmentDetails).sumBy(x => x.reimbursementCost).value() !== 0;
      });
    }
    return this.renderTableCell(
      getMultilevelGroupedData(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), true, 'Market'),
      []);
  };

  getTableRow = (marketReimburseData) => {
    let returnRows = [];

    returnRows = [...returnRows, ...this.renderTableRow(
      orderBy(marketReimburseData, this.state.orderBy, this.state.order)
    )];
    return returnRows;
  }

  // Function is used to handle sorting
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    let rows = [];
    rows = [...rows, ...this.renderTableRow(
      orderBy((this.state.marketReimburseData || []), property, isAsc ? 'desc' : 'asc')
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      rows
    }, () => { this.forceUpdate(); });
  };

  onClickOnArrow = (payPeriod, isCollapsed) => {
    const collapsePayPeriod = (this.state.payPeriod || []);
    collapsePayPeriod.find(d => d.payPeriod === payPeriod).isCollapsed = !isCollapsed;
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getTableRow(this.state.marketReimburseData || []);
    this.setState({
      payPeriod: collapsePayPeriod,
      handleCollapse: !this.state.handleCollapse,
      rows
    }, () => { this.forceUpdate(); });
  }

  // Function is used to render table
  renderTable = (rows) => {
    const groupSequence = this.getColumnSequence();
    const suppressColumns = this.getSupprssDetailsColumnCount();
    const isSensitiveData = IsSensitiveDataAccess();
    const { payPeriod } = this.state;
    const collapsableObj = isSensitiveData ? collapsableReimbursement : collapsableAllocationPercent;
    const extendibleArray = isSensitiveData ? extendibleMarkerReimbursArray : [collapsableAllocationPercent];

    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={rows.length}
          columnSequence={groupSequence}
          headCells={[]}
          payPeriod={payPeriod}
          isMarket={true}
          isSensitiveData={isSensitiveData}
          dynamicColumnCount={[1, 2, 3, 4, 5]}
          suppressDetailsColumnCount={suppressColumns}
          extendibleArray={extendibleArray}
          collapsableObj={collapsableObj}
          onClickOnArrow={this.onClickOnArrow}
          expand={this.state.expand}
          suppressDetails={this.state.advanceFilterConfig.suppressDetails}
          hideExpandBar={true}
        />
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  virtualOpen = () => {
    this.setState({
      showVirtual: true
    });
  }

  handleExport = (fileMimeType, type, isPrint) => {
    this.downloadFile(fileMimeType, type, isPrint);
  }

  // Function is used to download report into multiple formats like excel, pdf etc.
  downloadFile = (fileMimeType, type, isPrint) => {
    const { market, department, employee, payPeriodStartDate, advanceFilterConfig, expenseGroup, expenseName, division, SupervisorEmployee } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(payPeriodStartDate).format(DateFormat) }
    ];
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const expenseGroupId = _.cloneDeep(expenseGroup.map((x) => x.expenseGroupId));
    const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
    const divisionId = _.cloneDeep(division.map((x) => x.divisionId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
    dataValue.push({ key: 'DepartmentId', value: (departmentId.join('|') === undefined || departmentId.join('|') === '') ? '0' : departmentId.join('|') });
    dataValue.push({ key: 'EmployeeId', value: (employeeId.join('|') === undefined || employeeId.join('|') === '') ? '0' : employeeId.join('|') });
    dataValue.push({ key: 'ExpenseGroupId', value: (expenseGroupId.join('|') === undefined || expenseGroupId.join('|') === '') ? '0' : expenseGroupId.join('|') });
    dataValue.push({ key: 'ExpenseNameId', value: (expenseNameId.join('|') === undefined || expenseNameId.join('|') === '') ? '0' : expenseNameId.join('|') });
    dataValue.push({ key: 'DivisionId', value: (divisionId.join('|') === undefined || divisionId.join('|') === '') ? '0' : divisionId.join('|') });
    dataValue.push({ key: 'ShowSensitiveData', value: IsSensitiveDataAccess() });
    dataValue.push({ key: 'SuppressZero', value: advanceFilterConfig.suppressZero === true ? 1 : 0 });
    dataValue.push({ key: 'ProcessedYear', value: moment(moment(payPeriodStartDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year() });
    if (supervisorId && supervisorId.length > 0) {
      dataValue.push({ key: 'supervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }
    let url = '';
    if (advanceFilterConfig.suppressDetails === true) {
      url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Year%20End%20Bonus%20Market%20Reimbursement%20Summary%20Report', type);
    } else {
      dataValue.push({ key: 'ShowSummaryRow', value: advanceFilterConfig.summaryRows === true ? 1 : 0 });
      url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Year%20End%20Bonus%20Market%20Reimbursement%20Report', type);
    }
    downloadReport(
      url,
      'Year End Bonus Market Reimbursement Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  render() {
    const {
      showMain,
      employeeMasterData,
      departmentMasterData,
      marketMasterData,
      marketReimburseData,
      rows,
      expenseGroupMasterData,
      expenseNameMasterData,
      payPeriodStartDate,
      showReport,
      openSlidingPanel,
      advanceFilterConfig,
      expand,
      handleCollapse,
      divisionMasterData,
      supervisorEmployeeMasterData
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }
    if (departmentMasterData.find(x => x.departmentName === 'All') === undefined) {
      departmentMasterData.unshift({ departmentName: 'All' });
    }
    if (expenseGroupMasterData.find(x => x.expenseGroup === 'All') === undefined) {
      expenseGroupMasterData.unshift({ expenseGroup: 'All' });
    }
    if (expenseNameMasterData.find(x => x.expenseName === 'All') === undefined) {
      expenseNameMasterData.unshift({ expenseName: 'All' });
    }
    if (divisionMasterData.find(x => x.division === 'All') === undefined) {
      divisionMasterData.unshift({ division: 'All' });
    }

    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }

    return (
      <>
        {showMain
          ? (
            <Reports />
          )
          : (
            <>
              <PageHeader
                key={'Market_Reimbursement_Report'}
                title={'Year End Bonus Market Reimbursement Report'}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Year End Bonus Market Reimbursement Report
              </PageHeader>
              <Grid container spacing={3} className="no-print row top-xs" style={{ marginLeft: '10px' }}>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12} >
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      value={this.state.market}
                      onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                      id="tags-standard"
                      options={removeDuplicates(marketMasterData, 'marketName')}
                      getOptionLabel={(option) => option.marketName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Market"
                        // placeholder="Market"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.expenseGroup}
                      options={removeDuplicates(expenseGroupMasterData, 'expenseGroup')}
                      onChange={(e, val) => this.handleChange(e, val, 'expenseGroup', 'expenseGroup')}
                      getOptionLabel={(option) => option.expenseGroup}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Expense Group"
                        // placeholder="Property Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      options={removeDuplicates(departmentMasterData, 'departmentName')}
                      getOptionLabel={(option) => option.departmentName}
                      value={this.state.department}
                      onChange={(e, val) =>
                        this.handleChange(e, val, 'department', 'departmentName')
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Department"
                        // placeholder="Department"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.expenseName}
                      options={removeDuplicates(expenseNameMasterData, 'expenseName')}
                      onChange={(e, val) => this.handleChange(e, val, 'expenseName', 'expenseName')}
                      getOptionLabel={(option) => option.expenseName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Expense Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      options={removeDuplicates(employeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      value={this.state.employee}
                      onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Employee"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.division}
                      options={removeDuplicates(divisionMasterData, 'division')}
                      onChange={(e, val) => this.handleChange(e, val, 'division', 'division')}
                      getOptionLabel={(option) => option.division}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Division"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12} style={{ marginTop: '8px' }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          views={['year']}
                          margin="normal"
                          id="date-picker-dialog"
                          label="Year"
                          format="yyyy"
                          value={payPeriodStartDate}
                          name={'payPeriodStartDate'}
                          onChange={(e) =>
                            this.handleDateChange(e, 'payPeriodStartDate')
                          }
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          className="w-100"
                          inputProps={{ readOnly: true }}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      value={this.state.SupervisorEmployee || ''}
                      options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => {
                        this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Supervisor Name"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  data={marketReimburseData}
                  downloadFile={this.handleExport}
                  virtualOpen={this.virtualOpen}
                />
              </Grid>

              <div className="col-lg-3 buttons">
                <div className="col-lg-12">
                  <AdvancedFilter
                    payPeriodStartDate={this.state.payPeriodStartDate}
                    filterConfig={advanceFilterConfig}
                    onApplyFilter={this.onAddvanceFilterChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                </div>
              </div>
              {showReport &&
                (marketReimburseData === null ||
                  marketReimburseData.length <= 0) && (
                  <Grid container spacing={4}>
                    <Grid
                      container
                      direction="row-reverse"
                      justify="center"
                      alignItems="stretch"
                    >
                      <label className="item-big">No Data Available.</label>
                    </Grid>
                  </Grid>
                )}
                {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                  (marketReimburseData === null || marketReimburseData.length <= 0) && (
                    <PageLandingMessage/>
                  )
                } 
                { showReport &&
                  marketReimburseData !== null &&
                  marketReimburseData.length > 0 && (
                    <TableWithPaginations
                      tableData={rows}
                      renderTable={this.renderTable}
                      expand={expand}
                      handleCollapse={handleCollapse}
                      order={this.state.order}
                      oBy={this.state.orderBy}
                    />
                  )
                }
            </>
          )}
      </>
    );
  }
}
